<script>
import StampCell from './StampCell.vue';

/**
 * 14日 × 3帯 カレンダー風レイアウト。
 *
 * Props:
 *   - startDate: string ISO 'YYYY-MM-DD HH:mm:ss'
 *   - endDate:   string ISO
 *   - history:   {'YYYY-MM-DD': {slot1: bool, slot2: bool, slot3: bool}} の dict
 *   - newCell:   {date: 'YYYY-MM-DD', slot: 'slot1'|'slot2'|'slot3'} 当該セルに落下アニメを発火
 */
export default {
    name: 'StampCardCalendar',
    components: { StampCell },
    props: {
        startDate: { type: String, required: true },
        endDate: { type: String, required: true },
        history: { type: Object, default: () => ({}) },
        newCell: { type: Object, default: null },
        ajisaiImageUrl: { type: String, default: '' },
    },
    computed: {
        days() {
            const start = new Date(this.startDate);
            const end = new Date(this.endDate);
            const out = [];
            const cursor = new Date(start);
            cursor.setHours(0, 0, 0, 0);
            while (cursor <= end) {
                const yyyy = cursor.getFullYear();
                const mm = String(cursor.getMonth() + 1).padStart(2, '0');
                const dd = String(cursor.getDate()).padStart(2, '0');
                out.push(`${yyyy}-${mm}-${dd}`);
                cursor.setDate(cursor.getDate() + 1);
            }
            return out;
        },
    },
    methods: {
        slotAcquired(date, slot) {
            return !!(this.history[date] && this.history[date][slot]);
        },
        // 帯がイベント期間 [startDate, endDate] と重なるか。
        //   slot1: 00-08 / slot2: 08-16 / slot3: 16-24 (Asia/Tokyo)。
        //   重ならない帯 (初日 開始前 / 最終日 終了後) は空欄表示にする。
        slotInPeriod(date, slot) {
            const bands = { slot1: [0, 8], slot2: [8, 16], slot3: [16, 24] };
            const [h0, h1] = bands[slot];
            const [y, m, d] = date.split('-').map(Number);
            const slotStart = new Date(y, m - 1, d, h0, 0, 0, 0);
            const slotEnd = new Date(y, m - 1, d, h1, 0, 0, 0); // h1=24 は翌日0時に正規化される
            const start = new Date(this.startDate);
            const end = new Date(this.endDate);
            return slotStart < end && slotEnd > start;
        },
        slotIsNew(date, slot) {
            return this.newCell && this.newCell.date === date && this.newCell.slot === slot;
        },
        formatDayLabel(dateStr) {
            const d = new Date(dateStr);
            return `${d.getMonth() + 1}/${d.getDate()}`;
        },
    },
};
</script>

<template>
    <div class="stamp-card-calendar">
        <div v-for="date in days" :key="date" class="stamp-day">
            <div class="stamp-day-label">{{ formatDayLabel(date) }}</div>
            <div class="stamp-day-slots">
                <StampCell
                    :acquired="slotAcquired(date, 'slot1')"
                    :is-new="slotIsNew(date, 'slot1')"
                    :inactive="!slotInPeriod(date, 'slot1')"
                    :ajisai-image-url="ajisaiImageUrl"
                    label="朝"
                />
                <StampCell
                    :acquired="slotAcquired(date, 'slot2')"
                    :is-new="slotIsNew(date, 'slot2')"
                    :inactive="!slotInPeriod(date, 'slot2')"
                    :ajisai-image-url="ajisaiImageUrl"
                    label="昼"
                />
                <StampCell
                    :acquired="slotAcquired(date, 'slot3')"
                    :is-new="slotIsNew(date, 'slot3')"
                    :inactive="!slotInPeriod(date, 'slot3')"
                    :ajisai-image-url="ajisaiImageUrl"
                    label="夜"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
.stamp-card-calendar {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
    padding: 8px;
}
.stamp-day {
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 4px;
    background: #fcfcfc;
    min-width: 0;
}
.stamp-day-label {
    text-align: center;
    font-size: 10px;
    color: #666;
    margin-bottom: 2px;
}
.stamp-day-slots {
    display: flex;
    justify-content: center;
}
@media (max-width: 600px) {
    .stamp-card-calendar {
        grid-template-columns: repeat(3, 1fr);
    }
}
</style>
